interface NotePagetextControlProps {
    id: string;
    removeTextCallback: () => void;
    applyTextCallback: () => void;
}

class NotePagetextControl extends React.Component<NotePagetextControlProps, never> {
    private textboxId: string = "__tb001hwtmove";

    public componentDidMount(): void {
        $("#" + this.textboxId).focus();
    }

    public render(): JSX.Element {
        return (
            <div id={this.props.id} className="text-placeholder">
                <div className="dragger">
                    <span className="glyphicon glyphicon-move" />
                    <div className="right-btn">
                        <span onClick={() => this.props.removeTextCallback()} className="glyphicon glyphicon-remove" />
                        <span onClick={() => this.props.applyTextCallback()} className="glyphicon glyphicon-ok" />
                    </div>
                </div>
                <textarea id={this.textboxId} />
            </div>
        );
    }
}

export { NotePagetextControl };
